import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Card, Input, Row, Col, FormText } from "reactstrap";
import styles from 'components/styles.module.scss';
import { BEHAVIOUR } from 'helpers/constants';
import { getLocalizedText } from 'helpers/language';

const MultiSelectComponent = (props) => {
  const { data, index, isResponseWrong, errors, language } = props;
  return (
    <Card
      className={
        isResponseWrong
          ? `${styles["highlight-div"]} ${styles["card-ui"]} m-3 p-3`
          : `${styles["card-ui"]} m-3 p-3`
      }
    >
      <Row>
        <Col md={11} className={`${styles["custom-col"]} ps-1`}>
          <span>
            <span>
              {data.behaviour === BEHAVIOUR.MANDATORY ? "*" : null}
            </span>
            {index + 1}.
          </span>
          <div
            className={
              data.behaviour === BEHAVIOUR.MANDATORY
                ? `${styles["questions-ui"]} pe-0 ps-2`
                : "ps-2"
            }
            dangerouslySetInnerHTML={{
              __html: getLocalizedText(language, data.question, data.sp_question),
            }}
          ></div>
        </Col>
      </Row>
      <div className={`${styles["options-margin"]} mt-2 custom-input-label`}>
        {(data?.answer ?? []).map((item, id) => (
            <FormGroup key={id}>
              <Input
                type="checkbox"
                id={`${index}_${id}`}
                name={`${index}_${id}`}
                onChange={() => data.setSelectedOption(item, "multi")}
              />
              <label htmlFor={`${index}_${id}`}>
                {getLocalizedText(language, item.value, item.sp_value, ' | ')}
              </label>
            </FormGroup>
          ))}
        <div>
          <FormText className={styles["error-text"]} color="danger">
            {errors}
          </FormText>
        </div>
      </div>
    </Card>
  );
};

MultiSelectComponent.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isResponseWrong: PropTypes.bool,
  errors: PropTypes.string,
  language: PropTypes.string,
};

export default MultiSelectComponent;
